import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const [promoVisible, setPromoVisible] = useState(true);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="site-footer__inner">
        <div className="site-footer__top">
          <div className="site-footer__col">
            <h2 className="site-footer__col-title">FYI</h2>
            <ul className="site-footer__list">
              <li>
                <Link
                  className="site-footer__link"
                  to="/contact"
                  onClick={toTop}
                >
                  Contact Us
                </Link>
              </li>

              <li>
                <Link
                  className="site-footer__link"
                  to="/shipping"
                  onClick={toTop}
                >
                  Shipping Info
                </Link>
              </li>

              <li>
                <Link
                  className="site-footer__link"
                  to="/returns"
                  onClick={toTop}
                >
                  Returns &amp; Exchanges
                </Link>
              </li>
            </ul>
          </div>

          <div className="site-footer__col">
            <h2 className="site-footer__col-title">Stay Connected</h2>

            <p>works@mindredlane.watch</p>
            <p>899 Powers Ferry Rd a24, Marietta, GA 30067 US</p>
          </div>
        </div>

        <div className="site-footer__brand">
          <span className="site-footer__brand-script">Mindredlane</span>
        </div>

        <div className="site-footer__legal">
          <nav className="site-footer__legal-links" aria-label="Legal">
            <Link
              className="site-footer__legal-link"
              to="/privacy"
              onClick={toTop}
            >
              Privacy Policy
            </Link>
            <Link
              className="site-footer__legal-link"
              to="/terms"
              onClick={toTop}
            >
              Legal
            </Link>
          </nav>
          <p className="site-footer__copyright">
            © 2026 Mindredlane. All Rights Reserved.
          </p>
        </div>
      </div>

      {promoVisible ? (
        <div className="site-footer__promo" role="status">
          <button
            type="button"
            className="site-footer__promo-close"
            onClick={() => setPromoVisible(false)}
            aria-label="Dismiss promotion"
          >
            ×
          </button>
          <span>New Here? Take 15% Off</span>
        </div>
      ) : null}
    </footer>
  );
}

export default Footer;
